module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"form_name":{"label":"Category Name","placeholder":"Write category name here"}},"id":{"form_name":{"label":"Nama Kategori","placeholder":"Tulis Nama Kategori di sini"}}}')
  delete Component.options._Ctor
}
